import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../http-main.service';
import { ListModel, PaymentLinkResponseModel, PaymentRequestModel, PaymentResponseModel } from '@itb-monorepo/models';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class GatewayService {
  baseUrl = '/finance/';
  private _HttpMainService = inject(HttpMainService);

  getPaymentGateways(
    type: GateWayTypes
  ): Observable<ListModel<PaymentResponseModel>> {
    const qParams = {
      filter: `${type}:eq(true)`,
      sort: 'asc(priority)',
    };
    return this._HttpMainService.get(this.baseUrl + 'v1/gateways', qParams);
  }

  createPayment(
    gatewayCode: string,
    receiptId: string,
    model?: PaymentRequestModel
  ): Observable<HttpEvent<PaymentLinkResponseModel>> {
    let formData: FormData;
    if (model) {
      formData = new FormData();
      formData.append('file', model.file);
    }

    return this._HttpMainService.postFormData(
      this.baseUrl +
        `v1/gateways/${gatewayCode}/receipts/${receiptId}/payments`,
      formData
    );
  }
  editPayment(
    gatewayCode: string,
    receiptId: string,
    model?: PaymentRequestModel
  ): Observable<HttpEvent<PaymentLinkResponseModel>> {
    let formData: FormData;
    if (model) {
      formData = new FormData();
      formData.append('file', model.file);
    }

    return this._HttpMainService.patchFormData(
      this.baseUrl +
        `v1/gateways/${gatewayCode}/receipts/${receiptId}/payments`,
      formData
    );
  }
}

export type GateWayTypes = "withdraw" | "deposit";
